<script>
import Multiselect from "vue-multiselect";

export default {
    name: "AgencyFormPlatform",
    props: ['select_options', 'value', 'platform', 'disable', 'form'],
    components: {Multiselect},
    data: () => ({
        sources: [],
        sources_count_changes: 0,
        // isLoading: true,
    }),
    watch: {
        sources: {
            handler(val, old) {
                this.sources_count_changes++;
                this.$emit('input', val ? this.sources : null);
                if (this.sources_count_changes > 1) this.$emit('update');
            },
            deep: true,
        },
        value(val) {
            this.sources = val;
        },
    },
    mounted() {
        console.log('mounted');
        // this.isLoading = false;
        this.sources = this.value;
    },
    computed: {
        errors() {
            if (this.form && this.form.errors && this.form.errors.errors && this.form.errors.errors['sources.platform.' + this.platform.id]) {
                return this.form.errors.errors['sources.platform.' + this.platform.id];
            }
            return [];
        }
    },
    methods: {
        selectAll() {
            this.sources = this.select_options;
            // this.$emit('update');
        },
        clearAll() {
            this.sources = [];
            // this.$emit('update');
        },
        handlerUpdate() {
        //     this.$emit('update');
        }
    }
}
</script>

<template>
    <div :class="{'border-danger': errors.length, 'border': errors.length}">
        <template v-if="errors.length" v-for="error in errors">
            <div class="invalid-feedback d-block d-block p-2">{{error}}</div>
        </template>
        <label class="" :for="'source_platform' + platform.id + _uid">{{platform.name}}</label> <span class="text-muted small">(<a @click.prevent="selectAll" href="" >выбрать всё</a>, <a @click.prevent="clearAll" href="" >очистить</a>)</span>
        <multiselect
            class="multiselect-bootstrap"
            :id="'source_platform' + platform.id + _uid"
            v-model="sources"
            :options="select_options"
            :multiple="true"
            :taggable="true"
            :searchable="true"
            label="name"
            track-by="id"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            :selectedLabel="''"
            :placeholder="''"
            :selectLabel="''"
            :deselectLabel="''"
            :tagPlaceholder="''"
            @input="handlerUpdate"
        />
    </div>

</template>

<style scoped>

</style>